export default "__VITE_ASSET__7a2b393a__"